import React from 'react';
import { StickyNote, ChevronDown, ChevronRight } from 'lucide-react';

/*
 * NoteStrip — staff notes under a table row (the .note-strip treatment).
 * One line per note: a short head ("Call note · anita · 2 days ago") and the
 * note text. Render it only when there is a note, so rows without one keep
 * their height.
 *
 *   <NoteStrip lines={[{ key, label: 'Call note', meta: 'anita · 2 days ago', text }]} />
 *
 * Optional `toggle` ({ label, open, onClick }) adds the expand control used
 * for "N earlier" notes.
 */
export default function NoteStrip({ lines, toggle }) {
  if (!lines || lines.length === 0) return null;
  return (
    <div className="note-strip">
      <StickyNote className="note-strip-icon" size={14} strokeWidth={1.75} aria-hidden="true" />
      <div className="note-strip-lines">
        {lines.map(l => (
          <div className="note-line" key={l.key}>
            <span className="note-line-head" title={l.title || undefined}>
              <span className="note-line-label">{l.label}</span>
              {l.meta ? ` · ${l.meta}` : ''}
            </span>
            <span className="note-line-text">{l.text}</span>
          </div>
        ))}
      </div>
      {toggle && (
        <button type="button" className="note-strip-toggle" onClick={toggle.onClick} aria-expanded={toggle.open}>
          {toggle.open
            ? <ChevronDown size={13} strokeWidth={1.75} aria-hidden="true" />
            : <ChevronRight size={13} strokeWidth={1.75} aria-hidden="true" />}
          {toggle.label}
        </button>
      )}
    </div>
  );
}
